import React, {useEffect, useState} from 'react';
import './InsuranceTypeStep.scss';

const InsuranceTypeStep = ({insuranceType, sendData, setSendData}) => {

  const [subList, setSubList] = useState([]);

  useEffect(() => {
    if (sendData?.typeId !== "") {
      const subList = insuranceType.filter((item) => item.value === sendData?.typeId);
      if (subList[0]?.subGroups?.length > 0) {
        setSubList(subList[0].subGroups)
        setSendData({...sendData, typeSubId: subList[0].subGroups[0].value})
      } else {
        setSubList([])
        setSendData({...sendData, typeSubId: ""})
      }
    }
  }, [sendData?.typeId]);

  try {
    return (
      <>
        <ul className={"insurance-type"}>
          {insuranceType.length > 0 && insuranceType.map((item, index) => (
            <li key={"type" + index}
                onClick={() => setSendData({...sendData, typeId: item?.typeId, typeName: item?.typeName})}>
              <div className={`box-img ${sendData?.typeId === item?.typeId && "box-img-active"}`}>
                <img src={item?.typePicture} alt={"insurance-type"}/>
              </div>
              <h5>{item?.typeName}</h5>
            </li>
          ))}
        </ul>

        {subList.length > 0 &&
          <ul className={"insurance-sub-type"}>
            <li>انتخاب زیرگروه :</li>
            {subList.map((item, index) =>
              <li key={"type" + index} onClick={() => setSendData({...sendData, typeSubId: item?.value})}
                  style={sendData?.typeSubId === item?.value ? {
                    color: "#0F67B1",
                    fontWeight: "700"
                  } : {cursor: "pointer"}}>
                {item?.label}
              </li>
            )}
          </ul>
        }
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default InsuranceTypeStep;